import { Http } from '@/lib/http';

export class ChargedOffLoanService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/charged-off-loans/';
  }

  markLoansAsChargedOff() {

    return this.httpClient().get(this.endpoint);
  }

  getChargedOffLoans(params) {
    return this.httpClient().post(`${this.endpoint}search`, params);
  }

  createChargedOffCase(data) {
    return this.httpClient().post(this.endpoint, data);
  }

  updateChargedOffCase(data) {
    return this.httpClient().put(this.endpoint, data);
  }

  assignChargedOffLoanCase(data) {
    return this.httpClient().post(`${this.endpoint}assign`, data);
  }

  deassignChargedOffLoanCase(data) {
    return this.httpClient().patch(`${this.endpoint}deassign`, data);
  }

  getChargedOffLoanCaseSummary(loanId) {
    return this.httpClient().get(`${this.endpoint}loan/${loanId}`);
  }

  createChargedOffLoanCaseComment(data) {
    return this.httpClient().post(`${this.endpoint}comment/create`, data);
  }

  updateChargedOffLoanCaseComment(commentId, commentText) {
    return this.httpClient().patch(`${this.endpoint}comment/update`, {
      id: commentId,
      comment: commentText,
    });
  }

  getAssigneeChargedOffLoanCases(filters) {
    return this.httpClient().post(`${this.endpoint}workload`, filters);
  }
  
   getPendingChargedOffLoanCases(filters) {
    return this.httpClient().post(`${this.endpoint}pending-cases`, filters);
  }
  deleteChargedOffLoanCaseComment(commentId) {
    return this.httpClient().patch(`${this.endpoint}comment/delete/${commentId}`);
  }

  assignExternalParticipant(data) {
    return this.httpClient().post(`${this.endpoint}external-participant/assign`, data);
  }

  deassignExternalParticipant(data) {
    return this.httpClient().patch(`${this.endpoint}external-participant/deassign`, data);
  }
}
